export const SELL_TYPES_TICKETS = {
     CLIENTE_CREDITO: 10,
     CLIENTE_RECAUDO: 100
}